import Quill from "quill";

export const appConstants = {
  appEnv: process.env.REACT_APP_ENV,
  apiUrl: process.env.REACT_APP_API_URL,
  extractForm16DataURL: process.env.REACT_APP_EXTRACT_FORM_16_DATA_URL,
  extractStocksDataURL: process.env.REACT_APP_EXTRACT_STOCKS_DATA_URL,
  extractMutualFundsDataURL:
    process.env.REACT_APP_EXTRACT_MUTUAL_FUNDS_DATA_URL,
  appLogoUrl: process.env.REACT_APP_LOGO_URL, // to dispaly in Razorpay UI
  razorpaySecretKey: process.env.REACT_APP_RAZORPAY_KEY || "",
  portalUrl: process.env.REACT_APP_URL,
  basePath: process.env.REACT_APP_BASE_PATH || "",
  firebaseConfig: process.env.REACT_APP_FIREBASE_CONFIG,
  shortDateFormat: "MM/DD/YYYY hh:mm A",
  longDateFormat: "MMM DD YYYY hh:mm:ss A",
  dateTimeFormate: "DD MMM, YYYY hh:mm A",
  utcFormat: "YYYY-MM-DD",
  standardDateFormat: "YYYY-MM-DD",
  timeFormat: "hh:mm A",
  resendOtpTime: 60,
  NAME_REGEX: /^[A-Za-z.]+(?: [A-Za-z. ]*[A-Za-z. ])?$/i,
  CITY_NAME_REGEX: /^[A-Za-z\s.'-]+$/,
  // EMAIL_REGEX: /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/,
  EMAIL_REGEX: /^[\w.-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
  // EMAIL_REGEX:
  // 	/([\\.a-zA-Z0-9_\\-])+@([a-zA-Z0-9_\\-])+(([a-zA-Z0-9_\\-])*\\.([a-zA-Z0-9_\\-])+)+$/,
  PASSWORD_REGEX: /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/,
  SPECIAL_CHARS_REGEX: `${"[!@#%^&*(\")_+-$={}|;':,./<>?~`]\\"}`,
  DECIMAL_NUMBER_REGEX: /^\d*(\.\d{0,2})?$/,
  PAN_REGEX: /^[A-Z]{5}[0-9]{4}[A-Z]$/,
  TAN_REGEX:
    /^HYD[A-Z][0-9]{5}[A-Z]|VPN[A-Z][0-9]{5}[A-Z]|BBN[A-Z][0-9]{5}[A-Z]|BPL[A-Z][0-9]{5}[A-Z]|JBP[A-Z][0-9]{5}[A-Z]|CHE[A-Z][0-9]{5}[A-Z]|CMB[A-Z][0-9]{5}[A-Z]|MRI[A-Z][0-9]{5}[A-Z]|DEL[A-Z][0-9]{5}[A-Z]|CAL[A-Z][0-9]{5}[A-Z]|MRT[A-Z][0-9]{5}[A-Z]|AHM[A-Z][0-9]{5}[A-Z]|BRD[A-Z][0-9]{5}[A-Z]|RKT[A-Z][0-9]{5}[A-Z]|SRT[A-Z][0-9]{5}[A-Z]|BLR[A-Z][0-9]{5}[A-Z]|AGR[A-Z][0-9]{5}[A-Z]|KNP[A-Z][0-9]{5}[A-Z]|CHN[A-Z][0-9]{5}[A-Z]|TVD[A-Z][0-9]{5}[A-Z]|ALD[A-Z][0-9]{5}[A-Z]|LKN[A-Z][0-9]{5}[A-Z]|MUM[A-Z][0-9]{5}[A-Z]|NGP[A-Z][0-9]{5}[A-Z]|AMR[A-Z][0-9]{5}[A-Z]|JLD[A-Z][0-9]{5}[A-Z]|PTL[A-Z][0-9]{5}[A-Z]|RTK[A-Z][0-9]{5}[A-Z]|KLP[A-Z][0-9]{5}[A-Z]|NSK[A-Z][0-9]{5}[A-Z]|PNE[A-Z][0-9]{5}[A-Z]|PTN[A-Z][0-9]{5}[A-Z]|RCH[A-Z][0-9]{5}[A-Z]|JDH[A-Z][0-9]{5}[A-Z]|JPR[A-Z][0-9]{5}[A-Z]|SHL[A-Z][0-9]{5}[A-Z]$/,
  DOB_REGEX: /^([12]\\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\\d|3[01]))$/,
  AADHAAR_REGEX: /^[0-9]{12}$/,
  AADHAAR_ENROLMENT_REGEX: /^[0-9]{28}$/,
  OTP_DIGIT: /^\d+$/,
  // PINCODE_REGEX: /^[1-9]{1}[0-9]{5}$/, // contain exactly 6
  PINCODE_REGEX: /^[1-9][0-9]{5}(?:[0-9]{2})?$/, // contain exactly 6 or 8 digits only
  MOBILE_NUMBER: /[1-9]{1}[0-9]{9}|[1-9]{1}[0-9]{4,9}$/,
};

export const CurrentFinanceYear = new Date(
  `31 Mar ${new Date().getFullYear()}`
);

export const appInfo = {
  welcomeEmail: "",
  tollFreePhone: "",
  tollFreePhoneFormatted: "",
};

export const FileSizes = {
  MIN_FILE_SIZE: 10, // 10kb
  MAX_FILE_SIZE: 20 * 1024 * 1024, // 20MB
};

export const AllowedFileExt = [".jpg", ".jpeg", ".png", ".pdf"];

// roles used for auth navigation
export const AppAuthRoles = {
  ADMIN: "admin",
  CA: "ca",
  USER: "user",
};

// roles used for auth navigation
export const UserRoles = {
  ADMIN: "admin",
  CA: "ca",
  USER: "user",
};

export const UserStatusOptions = ["Active", "Inactive"];

export const publishStatusOptions: {
  [key: string]: string;
} = {
  false: "Unpublished",
  true: "Published",
};

export const IncomeSourcesOptions: {
  [key: string]: string;
} = {
  Salary: "Salary",
  Business: "Business",
};

export const QuillModules = {
  toolbar: [
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    ["bold", "italic", "underline", "blockquote", "strike"],
    [
      { list: "ordered" },
      { list: "bullet" },
      { indent: "-1" },
      { indent: "+1" },
    ],
    ["link", "image", "video"],
    [{ color: [] }, { background: [] }],
    [{ align: [] }],
    ["clean"],
  ],
  clipboard: {
    // toggle to add extra line breaks when pasting HTML:
    matchVisual: false,
  },
};

export const BlogQuillModules = {
  toolbar: [
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    ["bold", "italic", "underline", "strike", "blockquote"],
    [
      { list: "ordered" },
      { list: "bullet" },
      { indent: "-1" },
      { indent: "+1" },
    ],
    [{ align: [] }],
    ["link", "image", "video"],
    [{ color: [] }, { background: [] }],
    [{ font: [] }],
    [{ script: "sub" }, { script: "super" }],
    ["code-block", "clean"],
  ],
  clipboard: {
    matchVisual: false,
  },
  imageResize: {
    parchment: Quill.import("parchment"),
    modules: ["Resize", "DisplaySize"],
  },
  table: true,
  htmlEditButton: {
    debug: false,
    msg: "Edit HTML here",
    syntax: true,
  },
};
